import { gql } from "apollo-boost";

export const GET_USERS = gql`
  query Users(
    $where: UserWhereInput!
    $orderBy: OrderByInput
    $limit: Int
    $skip: Int
  ) {
    users(where: $where, orderBy: $orderBy, limit: $limit, skip: $skip) {
      data {
        username
        role
        phone
        firstName
        lastName
        createdAt
        id
        nickname
        gender
        email
        staffCode
        isDeleted
        address {
          village
          district
          province  
        }
        permission {
          id
          name
          note
          permissions
        }
      }
      total
    }
  }
`;

export const GET_STAFF_INFO = gql`
query Data($where: UserWhereInput!) {
  users(where: $where) {
    data {
      id
      nickname
      phone
      fbId
      voidIp
      firstName
      lastName
      image
      permission {
        id
        name
        note
        permissions
      }
      coverImages
      fbToken
      appleUserId
      fbTokenExpire
      mobileToken
      platform
      uid
      role
      gender
      shop {
        id
      }
      isVerified
      maritualStatus
      userSub
      email
      isOtp
      isConfirmed
      username
      createdAt
      updatedAt
      userAuthId
      userCode
      staffCode
      address {
        village
        district
        province
      }
    }
  }
}
`;
